import colors from '../colors.js'

let extendedColors = {
    goal:   '#ffffff',
    player: '#ffffff',
    playerLife: 'green'
}

for (let colorName in colors) {
    extendedColors[colorName] = colors[colorName]
}

export default {

    playerMinRadius: 0.15,
    playerMaxRadius: 0.2,
    playerAnimationRadiusSpeed: 4,

    playerShakeSpeed: 40,
    playerShakeIntensity: 0.03,

    cellRadius: 0.4,

    colors: extendedColors
}

